import { all } from "redux-saga/effects";
import { loginWatcherSaga } from "./Login/login.saga";
import { userManagementWatcherSaga } from "./UserManagement/userManagement.saga";
import { subscriptionWatcherSaga } from "./Subscription/subscription.saga";
import { hospitalManagementWatcherSaga } from "./HospitalManagement/hospitalManagement.saga";
import { candidateManagementWatcherSaga } from "./CandidateManagement/candidateManagement.saga";

export default function* rootSaga() {
  yield all([
    loginWatcherSaga(),
    userManagementWatcherSaga(),
    subscriptionWatcherSaga(),
    hospitalManagementWatcherSaga(),
    candidateManagementWatcherSaga(),
  ]);
}
